import { PropsWithChildren } from 'react'

import { useLexicalEditable } from '@lexical/react/useLexicalEditable'
import { Divider } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { DeleteNodeButton } from '../../../components/DeleteButton'
import { DownloadButton } from '../../../components/DownloadButton'
import { ToolbarContainer } from '../../ToolbarContainer'
import { useAttachmentCardStore } from '../Store/hooks/useStore'

import { PreviewAttachmentButton } from './PreviewButton'

export const AttachmentToolbar = ({ children }: PropsWithChildren) => {
  const editable = useLexicalEditable()
  const { nodeKey, ossUrl, filename } = useAttachmentCardStore(state =>
    pick(state, ['nodeKey', 'ossUrl', 'filename'])
  )

  return (
    <ToolbarContainer trigger='hover' triggerNode={children}>
      <PreviewAttachmentButton />
      <Divider orientation='vertical' />
      {editable ? (
        <DeleteNodeButton nodeKey={nodeKey} />
      ) : (
        <DownloadButton filename={filename} url={ossUrl} />
      )}
    </ToolbarContainer>
  )
}
